module HomePageView

open FSharpPlus
open Fable.React
open Fable.React.Props
open PortalLibs.Shared
open Fulma
open Model
open PortalLibs.Client.Components
open PortalLibs.Client.Components.Progress
open Shared
open Fable.FontAwesome
open PortalLibs.Client.Util
open System
open ContractPageModel
open HomePageModel
open Feliz

let primaryColor = "black"

let searchView value dispatch =
  let searchViewChanged =
    React.useCallback (SearchboxChanged >> dispatch, [||])

  div [ Style [ PaddingTop "10px" ] ] [
    SearchboxNew.SearchboxNew
      {| Value = value
         IsLoading = false
         IconVisible = false
         ValueChanged = searchViewChanged
         Key = "HomePageSearch"
         ShouldFocus = false |}
  ]

let card icon text value =
  div [ Class "contract-card"
        Style [
          Display DisplayOptions.Flex
          BoxShadow "0 0.25rem 0.125rem 0 rgba(0,0,0,0.1)"
          BorderRadius ".5rem"
          BackgroundColor "white"
          AlignItems AlignItemsOptions.Stretch
          MarginRight "15px"
          MarginBottom "10px"
          Width "100%"
          MaxWidth "373px"
        ] ] [
    div [ Style [
            Display DisplayOptions.Flex
            AlignItems AlignItemsOptions.Center
          ] ] [
      Icon.icon [ Icon.Size ISize.IsLarge
                  Icon.Props [
                    Style [ Color primaryColor ]
                  ] ] [
        Fa.i [ icon; (Fa.Size Fa.FaLarge) ] []
      ]
    ]
    div [ Class "contract-card-text"
          Style [
            BorderColor primaryColor
            BorderWidth "2px"
            Padding "0"
            Display DisplayOptions.Flex
            AlignItems AlignItemsOptions.Center
            //Width "230px"
            FlexGrow "1"
          ] ] [
      text
    ]
    div [ Style [
            Padding "0 15px"
            Display DisplayOptions.Flex
            AlignItems AlignItemsOptions.Center
            JustifyContent "center"
            ]
         ] [
      value
    ]
  ]

let loadingCard icon text valueOpt =
  card
    icon
    text
    (match valueOpt with
     | None ->
       Icon.icon [ Icon.Size ISize.IsLarge ] [
         Fa.i [ Fa.Solid.Spinner
                Fa.Pulse
                (Fa.Size Fa.Fa2x) ] []
       ]
     | Some value -> value)




let jobView model appSettings aiInfos isDemo dispatch (contract: Contract) =
  div [ Style [
          MarginTop "10px"
          MaxWidth "810px"
          MarginLeft "auto"
          MarginRight "auto"
        ] ] [
    Fulma.Message.message [ Message.Color(
                        if List.contains contract.Id model.VisitedContracts then
                          IColor.IsGreyLighter
                        else
                          IColor.IsLink
                      ) ] [
      Message.header [] [
        a [ OnClick (fun _ ->
              (contract.Id, Tab.Overview)
              |> ContractClicked
              |> dispatch) ] [
          $"%s{contract.Number |> Option.emptyStrIfNone} - %s{contract.Description |> Option.emptyStrIfNone}"
          |> str
        ]
      ]
      Message.body [ Props [
                       Style [
                         PaddingRight "10px"
                         BackgroundColor "#f0f0f5"
                       ]
                     ] ] [
        div [ Style [
                Display DisplayOptions.Flex
                FlexWrap "wrap"
                AlignItems AlignItemsOptions.Center
                Color "black"
                PaddingRight "0"
              ] ] [
          if isDemo then
            match Map.tryFind contract.Id aiInfos with
            | None -> ()
            | Some aiInfo ->
              yield
                card
                  Fa.Solid.Robot
                  (a [ OnClick (fun _ ->
                         (contract.Id, Tab.AI)
                         |> ContractClicked
                         |> dispatch) ] [
                    str "AI Success Rate"
                   ])
                  (CircleProgress(
                    {| percent = (aiInfo.SuccessRate * 100.0)
                       border = 50.0
                       key = $"AI-%i{contract.Id}" |}
                  ))
          yield
            card
              Fa.Solid.Percentage
              (a [ OnClick (fun _ ->
                     (contract.Id, Tab.Overview)
                     |> ContractClicked
                     |> dispatch) ] [
                str "Gross Profit Pct"
               ])
              (CircleProgress(
                {| percent = contract.GrossProfitPct * 100.0
                   border = 0.0
                   key = $"GP-%i{contract.Id}" |}
              ))

          if appSettings.HomeSettings.BillingAndCostGPPercent
             && Option.isSome contract.BCGPPercent then
            yield
              card
                Fa.Solid.Percentage
                (a [ OnClick (fun _ ->
                       (contract.Id, Tab.Overview)
                       |> ContractClicked
                       |> dispatch) ] [
                  str "Billing & Cost GP Pct"
                 ])
                (CircleProgress(
                  {| percent =
                      (contract.BCGPPercent |> Option.defaultValue 0.0)
                      * 100.0
                     border = 0.0
                     key = $"BCGP-%i{contract.Id}" |}
                ))
          yield
            loadingCard
              Fa.Solid.Percentage
              (a [ OnClick (fun _ ->
                     (contract.Id, Tab.ContractProfitFadeTab)
                     |> ContractClicked
                     |> dispatch) ] [
                str "Profit History"
               ])
              (Map.tryFind contract.Id model.ContractProfitFades
               |>> (fun profitFade ->
                 div [ Style [ Width "140px" ] ] [
                   ContractProfitFadePageView.profitFade profitFade
                 ]))
          if contract.UnapprovedInvoices > 0 then
            yield
              card
                Fa.Solid.FileInvoiceDollar
                (a [ OnClick (fun _ ->
                       (contract.Id, Tab.Overview)
                       |> ContractClicked
                       |> dispatch) ] [
                  str "Unapproved invoices"
                 ])
                (span [ Style [ Color "red"; FontWeight "bold" ] ] [
                  contract.UnapprovedInvoices |> string |> str
                 ])
          match model.ContractHomePageBuckets
                |> Map.tryFind contract.Id
            with
          | None -> ()
          | Some bucket ->
            if bucket.Value > 0.0 then
              yield
                card
                  Fa.Solid.HandHoldingUsd
                  (a [ OnClick (fun _ ->
                         (contract.Id, Tab.ARAndCashFlow)
                         |> ContractClicked
                         |> dispatch) ] [
                    str bucket.Label
                   ])
                  (span [ Style [ FontWeight "bold" ] ] [
                    bucket.Value
                    |> formatNumber
                         false
                         FormatCurrencyNegativeValues.MinusSign
                         true
                         FormatCurrencyRounding.AllZero
                    |> string
                    |> str
                   ])
          if contract.PendingChangeOrders > 0 then
            yield
              card
                Fa.Solid.Clock
                (a [ OnClick (fun _ ->
                       (contract.Id, Tab.ChangeOrders)
                       |> ContractClicked
                       |> dispatch) ] [
                  str "Pending Change Orders"
                 ])
                (span [ Style [ Color "red"; FontWeight "bold" ] ] [
                  contract.PendingChangeOrders |> string |> str
                 ])
          yield
            card
              Fa.Solid.DollarSign
              (a [ OnClick (fun _ ->
                     (contract.Id, Tab.CostAndBilling)
                     |> ContractClicked
                     |> dispatch) ] [
                str "Overall contract cash flow"
               ])
              (span [ Style [
                        if contract.CFNetCashFlow < 0.0 then
                          yield Color "red"
                        if contract.CFNetCashFlow > 0.0 then
                          yield Color "green"
                        yield FontWeight "bold"
                      ] ] [
                contract.CFNetCashFlow
                |> formatNumber true MinusSign true AllZero
                |> str
               ])
          if CostAndBilling.isOver30Days contract then
            let dateToDays (date: DateTime) = (DateTime.Now - date).TotalDays |> int

            let title, days =
              match contract.BillingLastRequestedDate, contract.LastBillDate with
              | None, None -> "", 0
              | Some date, None -> "Last Requested", dateToDays date
              | None, Some date -> "Last Billed", dateToDays date
              | Some requested, Some billed ->
                if billed >= requested then
                  "Last Billed", dateToDays billed
                else
                  "Last Requested", dateToDays requested

            yield
              card
                Fa.Solid.CalendarAlt
                (a [ OnClick (fun _ ->
                       (contract.Id, Tab.CostAndBilling)
                       |> ContractClicked
                       |> dispatch) ] [
                  str title
                 ])
                (span [ Style [
                          Color "red"
                          FontWeight "bold"
                          TextAlign TextAlignOptions.Center
                        ] ] [
                  $"%i{days} days" |> str
                 ])
          if contract.ActualLaborHoursToDate <> 0.0 then
            if appSettings.HomeSettings.AverageLaborRate then
              yield
                card
                  Fa.Solid.HardHat
                  (a [ OnClick (fun _ ->
                         (contract.Id, Tab.AverageRate)
                         |> ContractClicked
                         |> dispatch) ] [
                    str "Average Labor Rate"
                   ])
                  (span [ Style [ yield FontWeight "bold" ] ] [
                    contract.ActualLaborCostToDate
                    / contract.ActualLaborHoursToDate
                    |> formatNumber false MinusSign true FormatCurrencyRounding.Under1
                    |> str
                   ])

            if appSettings.AverageLaborRate_RemainingHours
               && contract.ActualLaborCostToDate
                  / contract.ActualLaborHoursToDate
                  <> 0.0 then
              yield
                card
                  Fa.Solid.Clock
                  (a [ OnClick (fun _ ->
                         (contract.Id, Tab.AverageRate)
                         |> ContractClicked
                         |> dispatch) ] [
                    str "Remaining Hours"
                   ])
                  (span [ Style [ yield FontWeight "bold" ] ] [
                    (contract.LaborCostToComplete
                     / (contract.ActualLaborCostToDate
                        / contract.ActualLaborHoursToDate))
                    |> sprintf "%.0f"
                    |> str
                   ])
        ]
      ]
    ]
  ]

let companyView
  model
  featureFlags
  aiInfos
  isDemo
  isSuperUser
  (coName, contracts: Contract list)
  isFirst
  dispatch
  =
  let heading =
    Heading.h5 [ Heading.Props [
                   Style [
                     MarginBottom "0"
                     Color "gray"
                     MarginLeft "-10px"
                   ]
                 ] ] [
      Icon.icon [ Icon.Size ISize.IsLarge ] [
        Fa.i [ Fa.Solid.Building
               (Fa.Size Fa.FaLarge) ] []
      ]
      str coName
    ]

  let contractsView contracts =
    contracts
    |> List.sortBy (fun (contract: Contract) -> contract.Number |> Option.emptyStrIfNone)
    |>> jobView model featureFlags aiInfos isDemo dispatch

  div [] [
    if not isFirst then yield hr []
    yield
      (if isFirst then
         div [ Style [
                 Display DisplayOptions.Flex
                 FlexDirection "row-reverse"
                 FlexWrap "wrap"
                 JustifyContent "center"
                 AlignItems AlignItemsOptions.Center
               ] ] [
           searchView model.SearchValue dispatch
           div [ Style [
                   FlexGrow "1"
                   PaddingTop "10px"
                 ] ] [
             heading
           ]
         ]
       else
         heading)
    if isSuperUser then
      yield!
        (contracts
         |> List.groupBy (fun contract -> contract.ProjectManager)
         |> List.sortBy fst
         |>> (fun (pm, pmContracts: Contract list) ->
           div [ Style [ PaddingBottom "15px" ] ] [
             yield
               Heading.h6 [ Heading.Props [
                              Style [
                                MarginBottom "-10px"
                                Color "blue"
                                MarginLeft "0px"
                                MarginTop "5px"
                              ]
                            ] ] [
                 Icon.icon [ Icon.Size ISize.IsLarge ] [
                   Fa.i [ Fa.Solid.User ] []
                 ]
                 pm |> emptyStrTagIfNone
               ]
             yield! contractsView pmContracts
           ]))
    else
      yield! contractsView contracts
  ]

let content model featureFlags aiInfos isDemo isSuperUser dispatch contracts =
  let contractsByCompany =
    contracts
    |> Map.toList
    |>> snd
    |> List.filter (fun (contract: Contract) ->
      (match model.SearchValue |> Option.noneIfEmptyStrOptTrim with
       | None -> true
       | Some txt ->
         (sprintf
           "%s %s %s"
           (contract.Number |> Option.emptyStrIfNone)
           (contract.Description |> Option.emptyStrIfNone)
           (if isSuperUser then
              (contract.ProjectManager |> Option.emptyStrIfNone)
            else
              ""))
           .ToLower()
           .Contains(txt.ToLower().Trim()))
      && contract.IsActive)
    |> List.groupBy (fun j -> $"%i{j.Co} - %s{j.CompanyName |> Option.emptyStrIfNone}")
    |> Seq.sortBy fst

  div [] [
    if (Seq.isEmpty contractsByCompany) then
      yield
        div [] [
          div [ Style [
                  Display DisplayOptions.Flex
                  JustifyContent "flex-end"
                  PaddingTop "6px"
                ] ] [
            searchView model.SearchValue dispatch
          ]
          div [ Style [
                  TextAlign TextAlignOptions.Center
                  Padding "50px 0"
                ] ] [
            str (
              if isSuperUser then
                "You are not following any active contracts yet, please go to the Contracts tab and select some!"
              else
                "There are no active contracts assigned to your user, please contact the administrator."
            )
          ]
        ]
    else
      yield!
        (contractsByCompany
         |> Seq.mapi (fun i m -> companyView model featureFlags aiInfos isDemo isSuperUser m (i = 0) dispatch))
  ]


let HomePageView =
  React.memo (
    "HomePageView",
    fun (props: {| Model: HomePageModel.Model
                   ApplicationSettings: ApplicationSettings
                   Contracts: Map<string, Contract> option
                   AiInfos: Map<ContractId, ContractAiInfo>
                   IsDemo: bool
                   IsSuperUser: bool
                   Dispatch: Msg -> unit |}) ->
      div [ Style [
              MarginTop "25px"
              MaxWidth "900px"
              MarginLeft "auto"
              MarginRight "auto"
            ] ] [
        loadingMessageBoxOrContent
          "Loading Contracts..."
          (content props.Model props.ApplicationSettings props.AiInfos props.IsDemo props.IsSuperUser props.Dispatch)
          props.Contracts
      ]
  )